import post from './post.js';
import get from './get.js';

export default {
	get: ({ session, app_uid }) => get('json/get', { session, app_uid }),
	save: ({ session, app_uid, data }) => post('json/save', { session, app_uid, data }),
};
